import CONFIG from '../config/config';
import { Meeting } from './MeetingsAPI';
import { instanceWith as APIClient } from './SimpleAPIClient';

export type FittingRoomBlockRequest = {
  startTime: string;
  endTime: string;
  title: string;
};

const FittingRoomsAPI = {
  block: (payload: FittingRoomBlockRequest) =>
    APIClient(CONFIG.API_ENDPOINT).post<Meeting>(`/v1/fitting-rooms/block`, payload),
};

export default FittingRoomsAPI;
